export function deleteParameterFromUrl(location, deleteName) {
  const url = new URL(location);
  url.searchParams.delete(deleteName)
  history.replaceState(null, null, url)
}
